import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {

    @Input() currentIndex: number;
    @Input() taskList: {
        done: boolean,
    }[];

    constructor() { }

    get progress() {
		let steps = this.taskList.filter(s => { return !!s.done });

		return (steps.length / (this.taskList.length-1));
    }

    // Return Font Awesome Class
    getClass(i) {
        if (this.isLastTask(i))
            return 'fas fa-star'

        if (this.isTaskDone(i)) {
            return 'fas fa-check';
        }

        return ''
    }

    // Return Task Number
    getText(i) {
        if (!this.isLastTask(i) && !this.isTaskDone(i))
            return i + 1;

        return ''
    }
    
    // Return classList
    getTaskClass(i) {
        let classes = [];

        if (i === this.currentIndex)
            classes.push('grow')

        if (this.isTaskDone(i) || i === this.currentIndex)
            classes.push('done')


        if (this.isLastTask(i)) {
            classes.push('last')
        }

        return classes.join(' ');
    }

    // Calculate the amount of margin on each side of the bootstrap progress bar
    // Shrinks progress bar to fit the steps
    getNgStyle() {
        let marginPerSide = (100 / this.taskList.length) / 2;

        return {
            'margin-left': `${marginPerSide}%`,
            'margin-right': `${marginPerSide}%`
        }
    }

    isTaskDone(i):boolean {
        return this.taskList[i] ? this.taskList[i].done: false;
    }

    isLastTask(i): boolean {
        return i === this.taskList.length -1;
    }

    isTaskActive(i: number) {
        return this.currentIndex === i;
    }
}
